namespace app.directives.controls.grid.renderers {

  export var JsonCellRenderer: agGrid.ICellRendererFunc = (params: any): HTMLElement | string => {
    return `<iio-json-viewer ng-model="data.actionDetails" button-text="View Details"></iio-json-viewer>`;
  };
}

// ES-module export so other modules can import directly
// (namespace exports are not ES module exports without this re-export)
export const JsonCellRenderer = app.directives.controls.grid.renderers.JsonCellRenderer;
